import React, { useState, useEffect } from 'react';
import api from '../api/axios';

const AcaryaRevenue = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRevenue();
  }, []);

  const fetchRevenue = async () => {
    try {
      const res = await api.get('/consultations/revenue');
      setData(res.data.data);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  if (loading) return (
    <div className="flex justify-center py-20 bg-[#0E0E26] min-h-screen">
      <div className="w-12 h-12 border-4 border-[#E8B84B]/20 border-t-[#E8B84B] rounded-full animate-spin"></div>
    </div>
  );

  return (
    <div className="p-8 bg-[#0E0E26] min-h-screen font-sans">
      <div className="mb-8">
        <h2 className="text-3xl font-black text-white uppercase tracking-widest">My Earnings</h2>
        <p className="text-white/40 text-sm font-bold uppercase tracking-widest mt-2">Track your consultation revenue and buyers</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
        <div className="bg-[#14122B] p-8 rounded-3xl border border-white/5 shadow-2xl">
          <div className="text-[#E8B84B] text-[10px] font-black uppercase tracking-widest mb-2">Total Revenue</div>
          <div className="text-4xl font-black text-white">₹{data?.stats?.totalRevenue || 0}</div>
        </div>
        <div className="bg-[#14122B] p-8 rounded-3xl border border-white/5 shadow-2xl">
          <div className="text-[#E8B84B] text-[10px] font-black uppercase tracking-widest mb-2">Total Minutes Sold</div>
          <div className="text-4xl font-black text-white">{data?.stats?.totalMinutesSold || 0}m</div>
        </div>
        <div className="bg-[#14122B] p-8 rounded-3xl border border-white/5 shadow-2xl">
          <div className="text-[#E8B84B] text-[10px] font-black uppercase tracking-widest mb-2">Unique Buyers</div>
          <div className="text-4xl font-black text-white">{data?.buyerCount || 0}</div>
        </div>
      </div>

      <div className="bg-[#14122B] rounded-3xl border border-white/5 overflow-hidden shadow-2xl">
        <div className="p-6 border-b border-white/5">
          <h3 className="text-white font-black uppercase tracking-widest text-sm">Recent Transactions</h3>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-black/20">
                <th className="p-4 text-[10px] font-black text-white/40 uppercase tracking-widest">Date</th>
                <th className="p-4 text-[10px] font-black text-white/40 uppercase tracking-widest">User</th>
                <th className="p-4 text-[10px] font-black text-white/40 uppercase tracking-widest">Minutes</th>
                <th className="p-4 text-[10px] font-black text-white/40 uppercase tracking-widest">Amount</th>
                <th className="p-4 text-[10px] font-black text-white/40 uppercase tracking-widest">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {data?.recentTransactions?.map((tx) => (
                <tr key={tx._id} className="hover:bg-white/5 transition-all">
                  <td className="p-4 text-xs text-white/60 font-bold uppercase tracking-tighter">
                    {new Date(tx.createdAt).toLocaleDateString()}
                  </td>
                  <td className="p-4">
                    <div className="text-sm font-bold text-white">{tx.userId?.name}</div>
                    <div className="text-[10px] text-white/20 uppercase font-black">{tx.userId?.email}</div>
                  </td>
                  <td className="p-4 text-sm font-black text-[#E8B84B]">{tx.minutes}m</td>
                  <td className="p-4 text-sm font-black text-white">₹{tx.amount}</td>
                  <td className="p-4">
                    <span className="bg-green-500/10 text-green-500 text-[9px] px-2 py-1 rounded font-black uppercase tracking-widest">
                      {tx.status}
                    </span>
                  </td>
                </tr>
              ))}
              {(!data?.recentTransactions || data.recentTransactions.length === 0) && (
                <tr>
                  <td colSpan="5" className="p-10 text-center text-white/20 text-xs font-black uppercase tracking-[0.3em]">
                    No transactions yet
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AcaryaRevenue;
